import config from "@config/config";

export const handleWialonLogin = () => {
  const callbackUrl = encodeURIComponent(
    `${window.location.origin}/wialon-redirect`
  );
  const wialonLoginUrl = `${config.wialonBaseLoginUrl}?access_type=-1&redirect_uri=${callbackUrl}&duration=0`;
  window.location.href = wialonLoginUrl;
};
